import { useQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { GET_TENANT } from 'graphql/tenants/queries/getTenant.gql';

export const useGetOneTenantQuery = ({
  id,
  fetchPolicy,
}: {
  id: number;
  fetchPolicy?: WatchQueryFetchPolicy;
}) => {
  const { data, error, loading, refetch } = useQuery(GET_TENANT, {
    skip: !id,
    fetchPolicy,
    variables: {
      id,
    },
  });

  const tenant = data?.tenant ?? undefined;
  return { tenant, loading, error, refetch };
};
